import React from "react";
import dayjs from "dayjs";
import { Typography } from "antd";
import { formatMoney } from "../../../../utils/util";
import TagItemTypes from "../../../../components/badge-and-tag/ERP/tags-item-type/TagItemTypes";

export const CATEGORY_ORDER = [
  "Raw Material",
  "Ingredients",
  "Packing Goods",
  "Finished Goods",
  "Work Instruction",
  "Packaging",
  "Packing",
];

// เกณฑ์สีของจำนวนคงเหลือ ปรับตัวเลขได้ตามความเหมาะสมของแต่ละหน่วยสินค้า
const LOW_QTY_THRESHOLD = 10;
const MEDIUM_QTY_THRESHOLD = 100;

const remainingTextType = (v) => {
  const num = Number(v || 0);
  if (num < LOW_QTY_THRESHOLD) return "danger";
  if (num < MEDIUM_QTY_THRESHOLD) return "warning";
  return "success";
};

const RemainingValue = ({ value }) => (
  <Typography.Text type={remainingTextType(value)} strong>
    {formatMoney(value, 2)}
  </Typography.Text>
);

export const summaryColumns = () => [
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 160,
    sorter: (a, b) => (a.stcode || "").localeCompare(b.stcode || ""),
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    sorter: (a, b) => (a.stname || "").localeCompare(b.stname || ""),
  },
  {
    title: "คงเหลือ",
    dataIndex: "remaining",
    key: "remaining",
    align: "right",
    width: 140,
    sorter: (a, b) => Number(a.remaining || 0) - Number(b.remaining || 0),
    render: (v) => <RemainingValue value={v} />,
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    width: 100,
    render: (v) =>
      v ? v : <Typography.Text type="secondary">-</Typography.Text>,
  },
];

export const allSummaryColumns = () => {
  const cols = summaryColumns();
  cols.splice(0, 0, {
    title: "ประเภท",
    dataIndex: "typename",
    key: "typename",
    width: 150,
    filters: CATEGORY_ORDER.map((c) => ({ text: c, value: c })),
    onFilter: (value, record) => record.typename === value,
    render: (v) => <TagItemTypes data={v} />,
  });
  return cols;
};

export const lotColumns = () => [
  {
    title: "เลขที่ Lot",
    dataIndex: "lot_no",
    key: "lot_no",
    width: 160,
    render: (v) =>
      v ? v : <Typography.Text type="secondary">รอบันทึก</Typography.Text>,
  },
  {
    title: "วันหมดอายุ",
    dataIndex: "expire_date",
    key: "expire_date",
    width: 140,
    // render: (v) => (v ? dayjs(v).format("YYYY-MM-DD") : "-"),
  },
  {
    title: "ที่จัดเก็บ",
    dataIndex: "location",
    key: "location",
    render: (v) => v || "-",
  },
  {
    title: "จำนวนคงเหลือ",
    dataIndex: "remaining",
    key: "remaining",
    align: "right",
    width: 140,
    render: (v) => <RemainingValue value={v} />,
  },
];
